<template>
  <div>
    <slot name="extras" />
    <el-select
      remote
      filterable
      v-model="inputValue"
      @change="handleInputConfirm"
      @focus="handleCheckFetch"
      :clearable="clearable"
      :disabled="disabled"
      :default-first-option="true"
      :remote-method="remoteMethod"
      :style="styleValue"
      :placeholder="errorMsg || placeholder"
      :loading="loading"
      :size="$xUISize"
    >
      <el-option
        v-for="item in selectOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    styleValue: {
      type: String,
      default: "width: 100%",
    },
    defaultFirst: {
      type: Boolean,
      default: false,
    },
    managerable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    value: {
      type: String
    },
  },
  watch: {
    value() {
      this.initValue();
    },
  },
  mounted() {
    this.initValue();
    this.remoteMethod("");
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      selectOptions: [],
      inputValue: "",
    };
  },
  methods: {
    initValue() {
      this.inputValue = this.value == "0" ? '' : this.value;
    },
    handleCheckFetch() {
      if (!this.selectOptions || this.selectOptions.length <= 0) {
        this.remoteMethod("");
      }
    },
    handleInputConfirm() {
      this.$emit("change", this.inputValue == '0' ? '' : this.inputValue);
    },
    handleFetchResp(resp) {
      this.selectOptions = [];
      this.selectOptions.push(...(resp.data.list || []).map((item) => {
        return { value: item.guid, label: item.categoryName };
      }))
      if (this.selectOptions.map(item => item.value).indexOf(this.value) < 0) {
        if (this.defaultFirst && this.selectOptions.length > 0) {
          this.inputValue = this.selectOptions[0].value;
        } else {
          this.inputValue = "";
        }
        this.handleInputConfirm();
      }
    },
    remoteMethod(query) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      this.selectOptions = [];
      this.requestApi("biz.goods.category.info.list", {
        categoryNameLike: query
      }, {
        cache: 1, cacheCallback: (resp) => {
          this.handleFetchResp(resp);
        }
      }).then((resp) => {
        this.loading = false;
        this.handleFetchResp(resp);
      }).catch((err) => {
        this.loading = false;
        this.errorMsg = (err && err.msg) || (err && err.message) || "数据加载失败";
      });
    },
  },
};
</script>